<template>
  <el-pagination
    @size-change="handleSizeChange"
    @current-change="changePage"
    :current-page="page"
    :page-sizes="pageSizeArr"
    :page-size="pageSize"
    layout="total, sizes, prev, pager, next, jumper"
    :total="count"
    background
  ></el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    count: Number,
    page: Number,
    pageSize: Number,
    pageSizeArr: Array,
  },
  methods: {
    handleSizeChange(val) {
      // 改变页面显示条数
      this.$emit('handleSizeChange', val)
    },
    changePage(page) {
      // 改变当前页
      this.$emit('changePage', page)
    },
  },
}
</script>

<style>
</style>